module.exports = __webpack_public_path__ + "img/DE00328.7fbfcaf8.png";